import { CountryStateSelect } from '@src/clients/financialSettings/CountryStateSelect';
import {
  AddressLine2Field,
  SaveCardOnFileField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import {
  AddressField,
  CityField,
  CountryCodeField,
  EmailField,
  FirstNameField,
  LastNameField,
  NameOnCardField,
  ZipField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import { NuveiForm } from '@src/clients/financialSettings/NuveiForm';
import { Checkbox } from '@src/common/components/Checkbox';
import { Divider } from '@src/common/components/Divider';
import { FormTextInput } from '@src/common/components/FormTextInput';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { CreditCardRelatedFields } from '@src/orders/fields/CreditCardRelatedFields';
import type { Control, FormState, UseFormWatch } from 'react-hook-form';
import type { UseFormRegister } from 'react-hook-form/dist/types/form';
import { useTranslation } from 'react-i18next';

interface Props {
  formState: FormState<CreditCardRelatedFields>;
  control: Control<CreditCardRelatedFields>;
  register: UseFormRegister<CreditCardRelatedFields>;
  watch: UseFormWatch<CreditCardRelatedFields>;
}

export const NewCreditCardFormContent = ({
  formState,
  control,
  register,
  watch,
}: Props) => {
  const { t } = useTranslation();

  const gap = theme.spacing['3'];

  const selectedCountryCode = watch(CountryCodeField.fieldName);
  return (
    <>
      <Stack gap={gap}>
        <Typography>{t('creditCardForm.creditCardInfo')}</Typography>
        <FormTextInput
          register={register}
          errors={formState.errors}
          fieldName={NameOnCardField.fieldName}
        />

        <NuveiForm />
      </Stack>

      <Divider
        sx={{ marginTop: theme.spacing['6'], marginBottom: theme.spacing['5'] }}
      />

      <Stack gap={gap}>
        <Typography>{t('billingInfo')}</Typography>

        <Stack direction="row" gap={gap}>
          <FormTextInput
            register={register}
            errors={formState.errors}
            fieldName={FirstNameField.fieldName}
          />

          <FormTextInput
            register={register}
            errors={formState.errors}
            fieldName={LastNameField.fieldName}
          />
        </Stack>

        <FormTextInput
          register={register}
          errors={formState.errors}
          fieldName={EmailField.fieldName}
        />

        <FormTextInput
          register={register}
          errors={formState.errors}
          fieldName={AddressField.fieldName}
        />

        <FormTextInput
          register={register}
          errors={formState.errors}
          fieldName={AddressLine2Field.fieldName}
        />

        <CountryStateSelect
          control={control}
          selectedCountryCode={selectedCountryCode}
        />

        <Stack direction="row" gap={gap}>
          <FormTextInput
            register={register}
            errors={formState.errors}
            fieldName={CityField.fieldName}
          />

          <FormTextInput
            register={register}
            errors={formState.errors}
            fieldName={ZipField.fieldName}
          />
        </Stack>
      </Stack>

      <Checkbox
        label={t('saveCardOnFile')}
        {...register(SaveCardOnFileField.fieldName)}
      />
    </>
  );
};
